<template>
  <a-card :bordered='false' class='p-b-80'>
    <SmallSquare class='m-b-60' content="1、如微信用户关注公众号后，48小时内没在该公众号做任何互动操作（如：点击菜单，发送消息，扫码等互动操作）48小时后将无法接收公众号推送的消息（包括交易通知，微客通知，积分通知等）。查看微信公众号详情说明 
2、消息中心推送：同步推送消息至消息中心，非公众号粉丝也可以在云店商城的个人中心接收到消息推送。
3、手机短信推送必须充值短信后才能发出推送。充值教程 发送明细" />
    <div class="square  s_c333 s_font_b s_b376c height-115 s_flex_bian_c p-l-25 p-r-25" style="box-shadow:0px 0px 22px 0px #dbe7f3;border-radius:10px">
      <div>
        <p>您当前剩余短信为 <span class='fz-34 s_cd41'>{{total}}</span> 条立即充值</p>
        <p>消息推送中，计费短信推送会扣除短信条数，为避免短信不足造成无法正常推送，请及时进行短信充值</p>
      </div>
      <div class='s_btn_D41C00' style="background-color:rgb(14,89,168)">
        立即充值</div>
    </div>
    <div class='pushInfo p-l-28' v-for="(v,k) in tableData" :key="k">
      <div class="pushInfoTitle fz-18 s_c333 m-t-20 m-b-35">{{k==0?'交易信息':'互动消息'}}</div>
      <div class="pushInfoList s_flex_ali s_flex_wrap">
        <router-link :to="'/messageCenter/newsPush/set?id='+value.id+'&total='+total" tag='div'
          class="pushInfoItem s_bor10 s_bor_cd9 s_bFBFCFC m-r-35 m-b-20 p-17 height-80 s_flex_ali"
          v-for="(value,index) in v" :key="index">
          <img :src="info.picdomain+'/'+value.icon" alt="" class="width-50 height-50 m-r-15">
          <div>
            <p class='m-b-13 fz-6'>{{value.name}}</p>
            <div :class="(value.sms||value.wx||value.message)?'theme_color':'s_c8e'" class="fz-12">
              {{(value.sms||value.wx||value.message)?'已启用':'未启用'}}
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </a-card>
</template>
<script>
  import { getSmsSurplus, getmessagePush, setmessagePush } from "@/api/message";
  import { computed, onMounted, reactive, ref, toRefs } from "vue";
  import store from '@/store';
  export default {
    setup() {
      const state = reactive({
        info: store.state.user.info,
      })
      // 获取剩余条数
      const total = ref(0);
      const getSurplus = async () => {
        let result = await getSmsSurplus()
          .then((res) => res.data)
          .catch((error) => error);
        total.value = result.data.num;
      };
      getSurplus()
      // 获取主页
      const tableData = ref([]);
      const initData = async () => {
        let result = await getmessagePush()
          .then((res) => res.data)
          .catch((error) => error);
        let list = [[], [], []];
        result.data.forEach((e) => {
          list[Number(e.type) - 1].push(e);
        });
        tableData.value = list;
      };
      let imgurl = computed({
        get: (data) => {
          return data
        }
      })
      onMounted(() => {
        initData();
      });
      return {
        ...toRefs(state),
        total,
        tableData,
        imgurl
      };
    },
  };
</script>

<style lang="less" scoped>
  .pushInfoItem {
    width: 270px;
  }
</style>